import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    headState: false,
    color: '#007455'
  },
  mutations: {
    navBg (state, headState) {
      state.headState = headState
    },
    Color(state,color){
      state.color = color
    }
  },
  actions: {
  },
  modules: {
  }
})
